module.exports = __webpack_public_path__ + "static/media/multiple.9c0814e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/multiple.svg
// module id = 1230
// module chunks = 0